export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Егер сіз мәмілені болдырмасаңыз, ол операцияны аяқтамай жабылады."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мәмілені болдырмағыңыз келетініне сенімдісіз бе?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Иә, болдырмау"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жоқ, белсенді қалдыру"])}
}